module.exports = __webpack_public_path__ + "img/heart.4851483d.svg";